import { Flex, Text } from '@welbe/design-system';

type CounterProps = {
	firstBranchOffice?: { id: string; name: string } | null;
	remainingBranchOfficesCount?: number;
};

export const Counter = ({
	firstBranchOffice,
	remainingBranchOfficesCount = 0,
}: CounterProps) => {
	if (!firstBranchOffice) return null;

	return (
		<Flex align="center" gap="4px">
			{firstBranchOffice.name}
			{remainingBranchOfficesCount > 0 && (
				<Text>+{remainingBranchOfficesCount}</Text>
			)}
		</Flex>
	);
};
